<template>
    <div class="solution-info">
      <section class="solution-box">
         <el-carousel :interval="7200" direction="vertical" arrow="always" style="height: 100%;">
            <!-- <el-carousel-item v-for="item in src" :key="item"  style="height: 100%;">
              <el-image style="width: 100%; height: auto" :src="item" fit="contain"></el-image>
            </el-carousel-item> -->
            <el-carousel-item class="pro-item-box" style="background: #67C23Ac8">
              <h2 class="small">国家卫健委等四部门印发《医疗机构检查检验结果互认管理办法》 3月1日起施行</h2>
              <span>国卫医发〔2022〕6号 <br></span>
              <span class="pro-title">2022-02-15<br></span>
              <div class="pro-detail"><b></b>各省、自治区、直辖市卫生健康委、中医药局、医保局，新疆生产建设兵团卫生健康委、医保局，军队各有关单位：<br>
                为进一步提高医疗资源利用率，减轻人民群众就医负担，保障医疗质量和安全，我们制定了《医疗机构检查检验结果互认管理办法》，现印发给你们，请认真贯彻执行。 <br></div>
                
            </el-carousel-item>
            <el-carousel-item class="pro-item-box" style="background: #409EFF">
              <h2 class="small">医联体数据中心</h2>
              <span>  物联网数据采集<br></span>
                <span>医联体数据共享交换统一治理 <br></span>
                <span>影像大数据集成平台</span>
              <div class="pro-detail"><b>医联体医学影像数据共享 ｜</b> 支持标准DICOM3.0接口医学信息技术，实现医联体内不同规模的医疗机构影像检查报告及DICOM影像互联互通可共享和交换、互查互访能互相调阅。构建区域医学影像共享平台，并在其上实现各种临床、教学、科研和管理的应用。 <br></div>
               
            </el-carousel-item>
            <el-carousel-item class="pro-item-box bg-o7">
              <h2 class="small">AI应用</h2>
                <span>CT 影像肺结节 <br></span>
                <span>云端计算、自动识别出 <br></span>
                <span>高效、快速、准确自动检测</span>
            </el-carousel-item>
          </el-carousel>
      </section>
    </div>
</template>
<script>
export default {
  name: "productInfo",
  data() {
    return {
    };  
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.imgzoIndex .solution-info {
    height: 100%;
}
.imgzoIndex .solution-info .solution-box {
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin-bottom: 8px;
    background: #fff;
}
.imgzoIndex .solution-info .pro-item-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
  color: var(--WhiteColor-1);
}
.imgzoIndex .solution-info .pro-item-box .pro-detail {
    padding: 32px;
    box-sizing: border-box;
    line-height: 160%;
}

</style>